import { createFetcher } from "api/helpers"

const fetcherConfiguration = {
  method: "get",
  makeRequestUrl: (host, user) => {
    return `${host}/users/${user}/get_pinned_projects`
  },
  checkRequiredArguments: (user) => {
    if (user === "undefined") throw Error("No user defined.")
  },
  makeResponseData: (data) => {
    return data?.pinned_projects
  }
}
export default createFetcher(fetcherConfiguration)
